// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__H2HDD","RotateSpinner":"Spinner_RotateSpinner__QFwKe"};